import React from "react";
import classNames from "classnames";
import { BsCheckLg } from "react-icons/bs";
import { CheckboxColor } from "store/types/enum";
import { FaMinus } from "react-icons/fa6";

interface CheckboxProps {
  checked: boolean;
  name: string;
  onChange?: () => void;
  className?: string;
  disabled?: boolean;
  visible?: boolean;
  width?: string;
  height?: string;
  checkboxColor?: CheckboxColor;
  partiallyFilled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  onChange = () => {},
  name,
  checked,
  className,
  disabled = false,
  visible = true,
  width = "w-5",
  height = "h-5",
  checkboxColor = CheckboxColor.Yellow,
  partiallyFilled = false,
}) => {
  const containerClasses = classNames(
    className,
    "relative inline-flex justify-center items-center shrink-0"
  );

  const checkboxClasses = classNames(
    "appearance-none rounded-md cursor-pointer w-full h-full transition-colors duration-150 focus:outline-none focus:ring-2",
    checkboxColor == CheckboxColor.Gray
      ? "border border-border bg-transparent focus:ring-ring/40"
      : "border border-primary/40 bg-transparent focus:ring-primary/20",
    checked &&
      (checkboxColor == CheckboxColor.Gray
        ? "border-primary/60 bg-primary/90"
        : "border-primary/60 bg-primary/20")
  );

  const checkmarkClasses = classNames(
    "absolute inset-0 rounded-md w-full h-full flex items-center justify-center pointer-events-none",
    checkboxColor == CheckboxColor.Gray ? "text-foreground" : "text-primary"
  );

  const disabledStyle = classNames(disabled ? " opacity-40" : "");
  const visibleStyle = classNames(visible ? "" : " opacity-0");

  return (
    <div className={classNames(containerClasses, width, height, disabledStyle, visibleStyle)}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        name={name}
        onChange={onChange}
        className={checkboxClasses}
      />
      {checked && (
        <div className={checkmarkClasses}>
          {partiallyFilled ? (
            <FaMinus className="text-[10px]" />
          ) : (
            <BsCheckLg className="text-[10px]" />
          )}
        </div>
      )}
    </div>
  );
};
